"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryProxies = void 0;

var _utils = require("./../common/utils");

var _service = require("./../service");

var _CrudBuilder = require("./../service/CrudBuilder");

const BasisTheoryProxies = new _CrudBuilder.CrudBuilder(class BasisTheoryProxies extends _service.BasisTheoryService {
  constructor(options) {
    const _options = { ...options
    }; // eslint-disable-next-line unicorn/prefer-spread

    _options.transformRequest = [].concat(_utils.transformProxyRequestSnakeCase, options.transformRequest || []); // eslint-disable-next-line unicorn/prefer-spread

    _options.transformResponse = [].concat(_utils.transformProxyResponseCamelCase, options.transformResponse || []);
    super(_options);
  }

}).create().retrieve().update().patch().delete().list().build();
exports.BasisTheoryProxies = BasisTheoryProxies;